var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreadsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "threads logo"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1535_6397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H48V48H0",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8159 18.75C19.969 17.0625 21.9377 15.75 25.0315 16.0312C28.1252 16.3125 30.9377 18.0938 30.769 24.0938C30.6002 30.0938 28.0315 32.1562 24.4596 32.2875C20.8877 32.4187 18.7409 30.2719 18.6846 27.9938C18.6284 25.7156 20.1096 22.9594 26.1096 23.0625C32.1096 23.1656 36.4877 25.9219 36.769 30.9375C37.0502 35.9531 32.4565 41.1094 24.2815 41.0625C16.1065 41.0156 9.6565 36.375 9.60962 24.2812C9.56275 12.1875 16.219 7.40625 24.0002 7.40625C31.7815 7.40625 36.5627 11.25 38.3627 17.8406",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8159 18.75C19.969 17.0625 21.9377 15.75 25.0315 16.0312C28.1252 16.3125 30.9377 18.0938 30.769 24.0938C30.6002 30.0938 28.0315 32.1562 24.4596 32.2875C20.8877 32.4187 18.7409 30.2719 18.6846 27.9938C18.6284 25.7156 20.1096 22.9594 26.1096 23.0625C32.1096 23.1656 36.4877 25.9219 36.769 30.9375C37.0502 35.9531 32.4565 41.1094 24.2815 41.0625C16.1065 41.0156 9.6565 36.375 9.60962 24.2812C9.56275 12.1875 16.219 7.40625 24.0002 7.40625C31.7815 7.40625 36.5627 11.25 38.3627 17.8406",
    stroke: "white",
    strokeWidth: 3.23438
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1535_6397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 7.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreadsLogo);
export default __webpack_public_path__ + "static/media/threads-logo.84ed456242b0a3dd3ac12bd96eed0d93.svg";
export { ForwardRef as ReactComponent };